// File generated automatically, do not modify

export interface AddressService {
  id?: string;
  name?: string;
  price?: number;
  isPriceFrom?: boolean;
  serviceId?: string;
  description?: string;
  duration?: number;
}

export interface AddressWithServices {
  address?: DoctorAddress;
  services?: AddressService[];
}

export interface AsyncTaskInfo {
  taskId: string;
  status: AsyncTaskStatus;
  progress: AsyncTaskProgress;
}

export interface AsyncTaskProgress {
  processed: number;
  total: number;
  percent: number;
  message?: string;
}

export enum AsyncTaskStatus {
  Waiting = 1,
  Running = 2,
  Finished = 3,
  Cancelling = 8,
  Cancelled = 9,
  Faulted = 99,
}

export interface Booking {
  id?: string;
  status?: string;
  startAt: string;
  endAt: string;
  duration?: string;
  bookedBy?: string;
  canceledBy?: string;
  bookedAt: string;
  canceledAt?: string;
  presence?: string;
  comment?: string;
  addressService?: AddressService;
  patient?: Patient;
}

export interface BookingMapping {
  mappingId?: string;
  docplanner?: Booking;
  his?: HisAppointment;
}

export interface Break {
  id?: string;
  since: string;
  till: string;
}

export enum CalendarState {
  Unknown = 0,
  Enabled = 1,
  Disabled = 2,
}

export interface CalendarStateDto {
  state: CalendarState;
}

export interface Doctor {
  id?: string;
  name?: string;
  surname?: string;
  licenseNumber?: string;
  licenseNumbers?: LicenseNumberItemsResponse;
}

export interface DoctorAddress {
  id?: string;
  name?: string;
  postCode?: string;
  street?: string;
  isOnlineOnly?: boolean;
}

export interface DoctorBookings {
  doctorMapping?: DoctorMapping;
  bookings?: BookingMapping[];
}

export interface DoctorMapping {
  mappingId?: string;
  mappingAutomatic?: boolean;
  docplanner?: DoctorWithAddress;
  his?: HisDoctorWithUnit;
}

export interface DoctorWithAddress {
  key?: string;
  doctor?: Doctor;
  facility?: Facility;
  address?: DoctorAddress;
  services?: AddressService[];
}

export interface DoctorWithAddresses {
  doctor?: Doctor;
  facility?: Facility;
  addresses?: AddressWithServices[];
}

export enum EventStatus {
  Waiting = 1,
  Completed = 2,
  Faulted = 3,
}

export interface Facility {
  id?: string;
  name?: string;
}

export interface HisAdmissionMode {
  id: number;
  nazwa?: string;
  kodNfz?: string;
  wymaganeSkierowanie?: boolean;
}

export interface HisAppointment {
  terminId: number;
  swiadczenieId: number;
  swiadczenieIdZewnetrzne?: string;
  pacjent?: HisPerson;
  jednostka?: HisUnit;
  platnik?: HisUnit;
  trybPrzyjecia?: HisAdmissionMode;
  zasobId?: number;
  dataOd?: string;
  dataDo?: string;
  dataRejestracji?: string;
  zaplanowanaProcedura?: HisServicePlan;
  zrealizowaneProcedury?: HisServicePlan[];
  skierowanie?: HisReferral;
  wpisKolejki?: HisAppointmentQueue;
  atrybuty?: HisAttribute[];
  status: number;
  powodPrzeplanowania?: string;
  powodOdwolania?: string;
  statusObecnosci?: number;
  kanalKontaktu: HisContactKind;
  komentarz?: string;
  komentarzZewnetrzny?: string;
}

export interface HisAppointmentQueue {
  kolejkaId: number;
  numer?: string;
  dataWpisania?: string;
  dataPlanowana?: string;
  skreslony?: boolean;
}

export interface HisAttribute {
  kod?: string;
  nazwa?: string;
  typ?: string;
  wartosc?: string;
}

export enum HisContactKind {
  Osobisty = 0,
  Wideo = 1,
  Audio = 2,
  Czat = 3,
}

export interface HisDictionaryEntry {
  id: number;
  kod?: string;
  wartosc?: string;
}

export interface HisDoctor {
  id: number;
  typ?: string;
  nazwa?: string;
  imie?: string;
  nazwisko?: string;
  npwz?: string;
  pesel?: string;
  typPersonelu?: HisDoctorType;
  specjalizacje?: HisSpeciality[];
  przypisaneJednostki?: HisDoctorAssignment[];
  jezyki?: HisLanguage[];
  posiadaGrafik?: boolean;
  rejestracjaZewnetrzna?: boolean;
  usunieto?: boolean;
}

export interface HisDoctorAssignment {
  jednostka?: HisUnit;
  specjalizacje?: HisSpeciality[];
  wymagaSkierowania?: boolean;
}

export interface HisDoctorType {
  id: number;
  nazwa?: string;
  kod?: string;
  kodNfz?: string;
}

export interface HisDoctorWithUnit {
  key: string;
  doctor?: HisDoctor;
  unit?: HisUnit;
}

export interface HisEvent {
  code?: string;
  id: string;
  requestId?: string;
  date: string;
  authorizedUserId?: number;
  organizationalUnitId?: number;
  targetUserIds?: number[];
  content?: any;
}

export interface HisLanguage {
  id: number;
  nazwa?: string;
  kod?: string;
  kodIso?: string;
}

export interface HisPerson {
  id: number;
  imie?: string;
  nazwisko?: string;
  pesel?: string;
  wiek?: number;
  plec?: string;
  dataUrodzenia?: string;
}

export interface HisReferral {
  dataWystawienia?: string;
  czyESkierowanie?: boolean;
  kodESkierowania?: string;
}

export interface HisSchedule {
  slots?: HisSlot[];
  bookings?: HisAppointment[];
}

export interface HisService {
  id: number;
  kod?: string;
  kodDodatkowy?: string;
  nazwa?: string;
  dostepnaDlaPortalu?: boolean;
  czasTrwania?: number;
  kanalKontaktu: HisContactKind;
  cenaMin?: number;
  cenaMax?: number;
  wiekOd?: number;
  wiekDo?: number;
  plec?: string;
  proceduraPlatnikaPodstawowego?: HisServiceBase;
  jednostkiRealizujace?: HisServiceUnit[];
  zasobyRealizujace?: HisDoctor[];
  platnicy?: HisUnit[];
  proceduryDodatkowe?: HisServiceBase[];
}

export interface HisServiceBase {
  id: number;
  kod?: string;
  kodDodatkowy?: string;
  nazwa?: string;
  dostepnaDlaPortalu?: boolean;
  czasTrwania?: number;
  kanalKontaktu: HisContactKind;
}

export interface HisServicePlan {
  id: number;
  kod?: string;
  kodDodatkowy?: string;
  nazwa?: string;
  dostepnaDlaPortalu?: boolean;
  czasTrwania?: number;
  kanalKontaktu: HisContactKind;
  proceduraPlatnikaPodstawowego?: HisServiceBase;
  cenaRezerwacji?: number;
}

export interface HisServiceUnit {
  jednostka?: HisUnit;
  nfz?: boolean;
  cena?: number;
  cenaKontrahenta?: number;
}

export interface HisSlot {
  dostepnoscId?: string;
  zasob?: HisDictionaryEntry;
  jednostka?: HisDictionaryEntry;
  procedura?: HisDictionaryEntry;
  od: string;
  do: string;
  komentarz?: string;
  gabinet?: string;
  zajetyWInnychJednostkach?: HisDictionaryEntry[];
}

export interface HisSpeciality {
  id: number;
  kod?: string;
  kodZewnetrzny?: string;
  nazwa?: string;
  nazwaZewnetrzna?: string;
}

export interface HisUnit {
  id: number;
  nazwa?: string;
  wewnetrzna?: boolean;
  platnik?: boolean;
  typ?: number;
}

export interface IntegrationConfigurationDto {
  clientId?: string;
  currentDate: string;
  maxActiveDate: string;
}

export interface IntegrationEventDto {
  id?: string;
  createdAt?: string;
  readAt: string;
  processedAt?: string;
  system: SystemType;
  status: EventStatus;
  type?: string;
}

export interface LicenseNumber {
  id?: string;
  licenseNumbers?: string;
}

export interface LicenseNumberItemsResponse {
  items?: LicenseNumber[];
}

export interface Patient {
  name?: string;
  surname?: string;
  email?: string;
  phone?: string;
  birthDate?: string;
  nin?: string;
  gender?: string;
}

export interface Schedule {
  slots?: Slot[];
  bookings?: Booking[];
  breaks?: Break[];
}

export interface ScheduleMapping {
  start: string;
  end: string;
  doctorMapping?: DoctorMapping;
  docplanner?: Schedule;
  his?: HisSchedule;
  error?: string;
}

export interface Service {
  id?: string;
  name?: string;
}

export interface ServiceMapping {
  mappingId?: string;
  docplanner?: Service;
  docplannerAddressService?: AddressService;
  docplannerDoctor?: DoctorWithAddress;
  his?: HisService;
}

export interface Slot {
  start: string;
}

export enum SystemType {
  Docplanner = 1,
  His = 2,
}
